export default "__VITE_ASSET__xavZwPfS__"